export default __webpack_public_path__ + "static/media/wusd.752131ab.png";